import { render, staticRenderFns } from "./StakeholderForm.vue?vue&type=template&id=239e546d&"
import script from "./StakeholderForm.vue?vue&type=script&lang=js&"
export * from "./StakeholderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports